import styled from 'styled-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BasicIconButton, Button } from 'components';
import { ReactComponent as EditOutlined } from 'assert/images/Profile/edit.svg';
import { Badge } from '@mui/material';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const CardContainer = styled.div`
  margin-bottom: 12px;
  color: ${({ theme }) => theme.text1};
  border: 1px solid ${({ theme }) => theme.border1};
  border-radius: 10px;
  font-size: 15px;
  position: relative;
  padding: 8px;
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .card-title {
      font-size: 15px;
      font-weight: 600;
    }
    .header-icons {
      position: absolute;
      right: 7px;
      top: 3.5px;
      > button {
        svg {
          width: 20px;
          height: 20px;
          path {
            fill: #6c6c6c;
          }
        }
      }
    }
  }
  .card-footer {
    border-top: 1px solid ${({ theme }) => theme.border1};
    padding-top: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    button {
      height: 26px;
    }
    .MuiBadge-badge {
      top: 3px;
      right: 3px;
    }
  }
`;

export const ProfileCard = ({
  title,
  content,
  updateDetails,
  EditIcon,
  FooterSection,
  ItemsLength,
  ExpendFun,
  customMaxLength
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { getProfile } = useSelector((state) => state?.ProfileSlice);

  const getUsername = location.pathname.split('/');
  const currentUsername = getUsername?.[getUsername?.length - 1]?.trim();

  return (
    <CardContainer>
      <div className="card-header">
        <div className="card-title">{t(title)}</div>
        <div className="header-icons">
          {!EditIcon && getProfile.username === decodeURIComponent(currentUsername) && (
            <BasicIconButton
              icon={<EditOutlined />}
              onClick={updateDetails}
              ariaLabel="edit-outlined"
              size="small"
            />
          )}
        </div>
      </div>
      <div>{content}</div>
      {FooterSection && ItemsLength > (customMaxLength || 3) && (
        <div className="card-footer">
          <Badge badgeContent={ItemsLength - 3} color="primary">
            <Button label={'Show all'} onClick={() => ExpendFun(true)} type={"outlined"} />
          </Badge>
        </div>
      )}
    </CardContainer>
  );
};
